import React from 'react';

const useModalControls = (initialVisibility = false) => {
  const [visible, setVisible] = React.useState(initialVisibility);

  const show = React.useCallback(() => setVisible(true), []);
  const hide = React.useCallback(() => setVisible(false), []);

  return { visible, show, hide };
};

export default useModalControls;
